import { render, staticRenderFns } from "./lectureDetail.vue?vue&type=template&id=b8a5c16a&scoped=true&"
import script from "./lectureDetail.vue?vue&type=script&lang=js&"
export * from "./lectureDetail.vue?vue&type=script&lang=js&"
import style0 from "./lectureDetail.vue?vue&type=style&index=0&id=b8a5c16a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5c16a",
  null
  
)

export default component.exports